import type { CopyShape } from "../../intl";

import type { PLAN_CATALOG_COPY_PT_BR } from "../plan-catalog.copy";

export const PLAN_CATALOG_COPY_ES_ES: CopyShape<typeof PLAN_CATALOG_COPY_PT_BR> = {
  priceOnRequestLabel: "Plan a medida",
  contactCtaLabel: "Habla con nosotros",
  monthlySuffix: "/mes",
};
